import React, { useState } from "react";
import Conversation from "./Conversation";
import chats from "../../images/chats.PNG";
import nav_img from "../../images/nav_img.PNG";

import FUNDACJA_HOSPICYJNA from "../../images/FUNDACJA_HOSPICYJNA.png";
import RC from "../../images/RC.png";
import LEGALIS from "../../images/LEGALIS.png";
import OIRP from "../../images/OIRP.jpg";
import OPERA_BALTYCKA from "../../images/OPERA_BALTYCKA.jpg";
import PRIMASOFT from "../../images/PRIMASOFT.png";

export default function Account() {
  const [showMessages, setShowMessages] = useState(false);

  function handleClick() {
    setShowMessages((prev) => !prev);
  }

  return (
    <div>
      <div className="organization-design" onClick={handleClick}>
        <div>
          <div className="text-1">Aplikacja "Dobre Ręce"</div>
          <div className="text-2">INFORMACJE O APLIKACJI</div>
          <div className="long-text" style={{ marginBottom: "2vh" }}>
            W świecie, który coraz bardziej docenia idee zero waste i
            zrównoważony rozwój, brakowało dotąd platformy łączącej ludzi
            chcących oddać niepotrzebne już im przedmioty z organizacjami
            dobroczynnymi, które mogą nadać im drugie życie.
          </div>
          <div className="long-text" style={{ marginBottom: "2vh" }}>
            Projekt „Dobre Ręce” to interaktywna mapa potrzeb materialnych,
            tworząca ekosystem pomocy w duchu gospodarki cyrkularnej – gdzie
            przedmiot zamiast stać się odpadem, staje się cennym zasobem dla
            lokalnej społeczności.
          </div>
          <div style={{ marginBottom: "2vh", fontSize: "1.8vh" }}>
            <div style={{ marginBottom: "0.6vh", fontWeight: "500" }}>
              Dlaczego warto korzystać z „Dobrych Rąk”?
            </div>
            <div style={{ marginBottom: "0.6vh" }}>
              <div style={{ display: "inline" }}>
                ♻️{" "}
                <span style={{ fontWeight: "500" }}>
                  Przeciwdziałasz marnotrawstwu!
                </span>
                <div style={{ textAlign: "justify" }}>
                  ➡️ Oddając używane przedmioty, zmniejszasz ilość odpadów w
                  mieście i dbasz o środowisko.
                </div>
              </div>{" "}
            </div>
            <div style={{ marginBottom: "0.6vh" }}>
              <div style={{ display: "inline" }}>
                🤝{" "}
                <span style={{ fontWeight: "500" }}>
                  Wspierasz lokalną społeczność!
                </span>
                <div style={{ textAlign: "justify" }}>
                  ➡️ Twoje niepotrzebne meble, ubrania czy sprzęty trafiają do
                  zweryfikowanych organizacji (schronisk, fundacji,
                  stowarzyszeń, noclegowni, szpitali etc), które najlepiej znają
                  potrzeby swoich podopiecznych.
                </div>
              </div>{" "}
            </div>
            <div style={{ marginBottom: "0.6vh" }}>
              <div style={{ display: "inline" }}>
                🏙️{" "}
                <span style={{ fontWeight: "500" }}>
                  Budujesz miasto przyszłości!
                </span>
                <div style={{ textAlign: "justify" }}>
                  ➡️ Gdzie zasoby krążą w obiegu zamkniętym, a pomoc materialna
                  jest efektywnie dystrybuowana.
                </div>
              </div>{" "}
            </div>
            <div style={{ marginBottom: "0.6vh" }}>
              <div style={{ display: "inline" }}>
                🔍{" "}
                <span style={{ fontWeight: "500" }}>
                  Masz gwarancję transparentności!
                </span>
                <div style={{ textAlign: "justify" }}>
                  ➡️ Współpracujemy wyłącznie z legalnie działającymi fundacjami
                  i stowarzyszeniami, dzięki czemu masz pewność, że Twoja
                  darowizna nie trafi do handlarza czy osoby, która nie
                  zasługuje na Twoją pomoc.
                </div>
              </div>{" "}
            </div>
            <div style={{ marginBottom: "0.6vh" }}>
              <div style={{ display: "inline" }}>
                📊{" "}
                <span style={{ fontWeight: "500" }}>
                  Przyczyniasz się do racjonalnej dystrybucji dóbr!
                </span>
                <div style={{ textAlign: "justify" }}>
                  ➡️ Organizacje na bieżąco zgłaszają i usuwają swoje potrzeby,
                  eliminując przypadkowość darowizn.
                </div>
              </div>{" "}
            </div>
            <div>
              <div style={{ display: "inline" }}>
                🌱{" "}
                <span style={{ fontWeight: "500" }}>
                  Uwzględniasz ekologię w swoim w działaniu!
                </span>
                <div style={{ textAlign: "justify" }}>
                  ➡️ Przedłużasz życie przedmiotów, które nie są Ci już
                  potrzebne
                </div>
              </div>{" "}
            </div>
          </div>
          <div className="long-text" style={{ marginBottom: "2vh" }}>
            W zrównoważonym mieście nie ma rzeczy niepotrzebnych – są tylko źle
            rozmieszczone zasoby. Dzięki «Dobrym Rękom» Twój stary fotel może
            dać wytchnienie w świetlicy dla bezdomnych, a nieużywany laptop –
            pomóc w nauce dzieciom z ubogich rodzin.
          </div>
          <div className="long-text" style={{ marginBottom: "2vh" }}>
            Twoja szafa, piwnica lub garaż mogą kryć przedmioty, które dla kogoś
            staną się bezcenne. Sprawdź mapę „Dobrych Rąk” i przekonaj się, jak
            łatwo jest pomagać mądrze i ekologicznie!
          </div>
          <div className="long-text" style={{ marginBottom: "2vh" }}>
            Wierzymy, że mając precyzyjną informację o zapotrzebowaniu
            wiarygodnych organizacji dobroczynnych, jako osoba o Dobrym Sercu
            znajdziesz w sobie energię aby w wolnej chwili zawieźć niepotrzebną
            Ci rzecz i oddać ją w wybrane przez Ciebie Dobre Ręce.
          </div>
          <span
            style={{
              fontWeight: "500",
              display: "flex",
              justifyContent: "center",
              fontSize: "1.8vh",
            }}
          >
            Projekt "Dobre Ręce" wspierają:
          </span>
          <div className="logo-img">
            {/* <img src={FUNDACJA_HOSPICYJNA} /> */}
            {/* <img src={RC} /> */}
            <img src={LEGALIS} />
            {/* <img src={OIRP} /> */}
            {/* <img src={OPERA_BALTYCKA} /> */}
            <img src={PRIMASOFT} />
          </div>
        </div>
        {/*<img src={chats}></img>*/}
      </div>
      {/*showMessages && (
        <div className="organization">
          <div className="conversation_nav" onClick={handleClick}>
            <img
              className="nav_img" src={nav_img}
            />
          </div>
          <Conversation />
        </div>
      )*/}
    </div>
  );
}
